import React from 'react';
import { Flex, Spin } from 'antd';

interface SpinnerProps {
  isLoading: boolean;
}

const Spinner: React.FC<SpinnerProps> = ({ isLoading }) => {
  return (
    <>
      <Flex align="center" gap="middle">
        <Spin spinning={isLoading} fullscreen />
      </Flex>
    </>
  );
};

export default Spinner;
